import {UserActions, UserActionTypes} from "@/store/action/user";
import {TUserEquity} from "@/api/auth";

const initialState = {
    userToken: '',
    video_balance: 0 as TUserEquity['video_balance'],
    is_vip_week_v24_03_04: false,
    vip_week_v24_03_04_end_time: 0 as TUserEquity['vip_week_v24_03_04_end_time'],
    is_vip_month_v24_03_04: false,
    vip_month_v24_03_04_end_time: 0 as TUserEquity['vip_month_v24_03_04_end_time'],
    share_code: '' as TUserEquity['share_code'],
}

export function user(state = initialState, {type, payload}: {
    type: UserActionTypes, payload: UserActions['payload']
}): typeof initialState {
    const DateNow = new Date().getTime();
    switch (type) {
        case UserActionTypes.InitUserToken:
            state.userToken = payload as string
            break;
        case UserActionTypes.InitUserVideoBalance:
            state.video_balance = payload as TUserEquity['video_balance']
            break;
        case UserActionTypes.InitVipMonthV24_03_04EndTime:
            state.vip_month_v24_03_04_end_time = payload as TUserEquity['vip_month_v24_03_04_end_time'];
            state.is_vip_month_v24_03_04 = DateNow < payload;
            break;
        case UserActionTypes.InitVipWeekV24_03_04EndTime:
            state.vip_week_v24_03_04_end_time = payload as TUserEquity['vip_week_v24_03_04_end_time'];
            state.is_vip_week_v24_03_04 = DateNow < payload;
            break;
    }
    return {
        ...state
    };
}